import React from "react";

// Helper function to render tasks recursively
const renderTasks = (tasks) => (
  <ul>
    {tasks.map((task, i) => {
      if (typeof task === "string") {
        return <li key={i}>{task}</li>;
      }

      if (typeof task === "object") {
        return (
          <li key={i}>
            {task.text}
            {task.subtasks && renderTasks(task.subtasks)}
          </li>
        );
      }

      return null;
    })}
  </ul>
);

export default function Experience() {
  const experiences = [
    {
      company: "Skyach Software Solutions Pvt. Ltd.",
      role: "Software Developer → Team Lead → Project Manager",
      period: "November 2017 – Present",
      location: "Mohali, Chandigarh",
      tasks: [
        "Harpreet Singh joined Skyach Software Solutions Pvt. Ltd. as a Software Developer, working on application development, debugging, feature enhancements, and software maintenance.",

        "After approximately 1.5 years, he was promoted to Team Lead, managing developers, coordinating development activities, reviewing work, and ensuring timely task completion.",

        {
          text: "As Project Manager, responsibilities include:",
          subtasks: [
            "End-to-end project planning and execution",
            "Client interaction and requirement analysis",
            "Sprint planning, task allocation, and delivery tracking",
            "Code reviews, quality assurance, and documentation",
            "Risk management and delivery coordination",
            "Ensuring on-time delivery and client satisfaction"
          ]
        },

        "Played an active role in adopting new technologies and improving development processes, efficiency, and product quality.",

        {
          text: "Professional responsibilities across software projects:",
          subtasks: [
            "Contributed to application development, feature implementation, debugging, and maintenance.",
            "Led development teams while supporting coding standards, code reviews, mentoring, and timely delivery.",
            "Managed software projects from requirements through development, testing, deployment, and delivery.",
            "Worked with clients and stakeholders to understand requirements and coordinate project execution.",
            "Worked closely with cross-functional teams to deliver scalable, secure, and high-performance software applications.",
            "Guided and mentored freshers during their onboarding and training phase.",
            "Coordinated with trainers to monitor training progress and quality without directly conducting training sessions.",
            "Reviewed and validated final project submissions prepared during training at regular intervals.",
            "Collaborated with HR teams in screening and recruiting IT employees by providing technical evaluation and feedback.",
            "Ensured newly onboarded resources were project-ready before allocation to live projects."
          ]
        }
      ]
    },

    {
      company: "Institute of Management Sciences (IMS)",
      role: "Assistant Professor – Computer Science",
      period: "September 2014 – October 2017",
      location: "Jammu & Kashmir",
      tasks: [
        "Harpreet Singh taught Computer Science subjects to Undergraduate and Postgraduate (MCA) students.",
        "Guided students in academic and final-year projects.",
        "Managed and maintained the MCA Computer Laboratory, including hardware, software, and networking.",
        "Designed, developed, and maintained the college website (imsjammu.com).",
        "Kept track of emerging technologies and introduced students to modern tools and practices."
      ]
    },

    {
      company: "NIIT Rehari, Jammu",
      role: "Senior System Executive",
      period: "October 2013 – September 2014",
      location: "Jammu",
      tasks: [
        "Harpreet Singh delivered training in Computer Science subjects.",
        "Managed network infrastructure and system maintenance.",
        "Acted as in-charge of the maintenance and networking cell."
      ]
    },

    {
      company: "National Informatics Centre (NIC), Government of India",
      role: "Programmer",
      period: "October 2011 – October 2013",
      location: "SRS Library, Jammu",
      tasks: [
        "Harpreet Singh managed IT systems and operations of the library.",
        "Supervised Data Entry Operators and coordinated daily technical activities.",
        "Worked as System Administrator, ensuring system security, availability, and performance."
      ]
    },

    {
      company: "Care College (PTU Study Centre)",
      role: "Senior Faculty",
      period: "2011 – 2013",
      location: "Jammu & Kashmir",
      tasks: [
        "Harpreet Singh taught Computer Science subjects to Undergraduate and Postgraduate students of Punjab Technical University.",
        "Assisted students with coursework and project development."
      ]
    }
  ];

  return (
    <section id="experience">
      <h2>Professional Experience — Harpreet Singh</h2>

      <div className="timeline">
        {experiences.map((exp, index) => (
          <div
            key={index}
            className={`timeline-item ${
              index % 2 === 0 ? "fade-left" : "fade-right"
            }`}
          >
            <h3>{exp.company}</h3>

            <span>{exp.role}</span>

            <p>
              {exp.period}
              {exp.location && ` | ${exp.location}`}
            </p>

            {renderTasks(exp.tasks)}
          </div>
        ))}
      </div>
    </section>
  );
}
